import { render, staticRenderFns } from "./ModalCookies.vue?vue&type=template&id=f6de5c90&scoped=true"
import script from "./ModalCookies.vue?vue&type=script&lang=js"
export * from "./ModalCookies.vue?vue&type=script&lang=js"
import style0 from "./ModalCookies.vue?vue&type=style&index=0&id=f6de5c90&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6de5c90",
  null
  
)

export default component.exports